import { ts } from '_core';

import { getName, validate } from './helpers';
import { DraftParams } from './types';

export default [
  {
    key: ts.enums.REPORT_ENUMS.WIDGET_KEY_ENUM.SIGNAL_CORRELATION_ANALYSIS,
    title: 'Correlation With Another Signal',
    helpLabel: 'signal_correlation_analysis',
    form: true,
    defaultParams: {
      analysis_pipelined_signals: [],
      format_for_ui: true,
    } as DraftParams,
    neededFiles: ['signal_correlation_analysis'],
    tags: [ts.enums.REPORT_ENUMS.REPORT_TAG_ENUM.SIGNAL],

    getName,
    validate,
  },
] satisfies ts.types.analysis.WidgetConfig[];
